module.exports = __webpack_public_path__ + "static/media/online-tuition-touchpad-box.4d8124f1.jpg";